// HelpCenterUtils.ts

import type { FAQSection } from "./HelpCenterData";

/**
 * Vimeo oEmbed expects a public vimeo page URL (https://vimeo.com/<id>),
 * not the player URL. We extract the ID and convert.
 */
export function extractVimeoId(url: string): string | null {
  // Handles:
  // - https://player.vimeo.com/video/1156549470?h=...
  // - https://vimeo.com/1156549470
  const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  return m?.[1] ?? null;
}

export function toVimeoPageUrl(videoUrl: string): string | null {
  const id = extractVimeoId(videoUrl);
  return id ? `https://vimeo.com/${id}` : null;
}

export function buildAutoplayUrl(url: string): string {
  // If it's already got autoplay=, don't add again (same guard as toDownloadUrl below)
  if (url.toLowerCase().includes("autoplay=")) return url;

  const join = url.includes("?") ? "&" : "?";
  return `${url}${join}autoplay=1`;
}

// export async function fetchVimeoThumbnail(videoUrl: string): Promise<string | null> {
//   const pageUrl = toVimeoPageUrl(videoUrl);
//   if (!pageUrl) return null;

//   const res = await fetch(
//     `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(pageUrl)}`
//   );
//   if (!res.ok) return null;

//   const data = (await res.json()) as { thumbnail_url?: string };
//   return data.thumbnail_url ?? null;
// }
// HelpCenterUtils.ts

export async function fetchVimeoThumbnail(videoUrl: string): Promise<string | null> {
  try {
    const res = await fetch(
      `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`
    );
    if (!res.ok) return null;

    const data = (await res.json()) as { thumbnail_url?: string };
    return data.thumbnail_url ?? null;
  } catch (e) {
    console.error("Failed to load thumbnail", e);
    return null;
  }
}


/**
 * Box share links can usually be forced into a direct download by appending ?download=1
 * This keeps it simple and works well for common Box share URLs.
 */
export function toDownloadUrl(url: string): string {
  const hasQuery = url.includes("?");
  const join = hasQuery ? "&" : "?";

  // If it's already got download=, don't add again
  if (url.toLowerCase().includes("download=")) return url;

  // Works for Box share links and is harmless for most URLs
  return `${url}${join}download=1`;
}

export function countFaqs(sections: FAQSection[]): number {
  return sections.reduce((acc, s) => acc + s.items.length, 0);
}

export function filterSections(sections: FAQSection[], query: string): FAQSection[] {
  const q = query.trim().toLowerCase();
  if (!q) return sections;

  return sections
    .map((s) => ({
      ...s,
      items: s.items.filter((it) => {
        const qText = it.q.toLowerCase();
        const aText = typeof it.a === "string" ? it.a.toLowerCase() : "";
        return qText.includes(q) || aText.includes(q);
      }),
    }))
    .filter((s) => s.items.length > 0);
}
